// Unified dashboard colors
export const DASHBOARD_COLORS = {
  background: '#f7f7f7',
  header: '#556780',
  text: '#333333',
  mutedText: '#6c757d',
  success: '#28a745',
  warning: '#F0B800',
  error: '#dc3545',
  primary: '#007bff',
};

// Common MUI styles used across dashboard components
export const COMMON_STYLES = {
  sectionPaper: {
    p: 2,
    backgroundColor: DASHBOARD_COLORS.background,
    borderRadius: 2,
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  batteryDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    mb: 1,
  },
};
